import { getTestSeriesLabel, getVerticalIdFromProfilesData } from "@repo/utils";
import { useModuleData } from "../context/ModuleDataContext";

/**
 * Returns the user-facing label for the ILTS / test series entry,
 * resolved from the current user's vertical.
 */
export const useTestSeriesLabel = (): string => {
  const { profilesData } = useModuleData();
  return getTestSeriesLabel(getVerticalIdFromProfilesData(profilesData));
};
